import { useEffect } from "react";
import { Emitter } from "mitt";

export function useEventListener<
  Events extends Record<string, any>,
  K extends keyof Events
>(
  eventBus: { emitter: Emitter<Events> },
  type: K,
  handler: (event: Events[K]) => void
) {
  useEffect(() => {
    eventBus.emitter.on(type, handler);
    return () => {
      eventBus.emitter.off(type, handler);
    };
  }, [eventBus, type, handler]);
}

export default useEventListener;

